// extracted by mini-css-extract-plugin
var _1 = "SCuNI75Tt65txcBnJUNk";
var _2 = "viMC6BWKDGfxxFqQJJtg";
var _3 = "L4bG244J1930BfvZ_KfO";
var _4 = "fHEwROwNUwNVvQrOtb9U";
export { _1 as "button", _2 as "light", _3 as "margin", _4 as "wrapper" }
